import Appsignal from "@appsignal/javascript";
import { plugin as networkBreadcrumbsPlugin } from "@appsignal/plugin-breadcrumbs-network";
import { plugin as windowEventsPlugin } from "@appsignal/plugin-window-events";
import AlreadyReportedError from "../classes/alreadyReportedError";
import pathOf from "../functions/pathOf";
import config from "./config";

export const appsignal = new Appsignal({
  key: config.appsignal.apiKey,
  namespace: "frontend",
  revision: config.revision,
  // The window-events plugin reports what callers leave unhandled, and an AlreadyReportedError is
  // a response the check has reported or a request the user left. The message has no regex
  // metacharacters.
  ignoreErrors: [new RegExp(`^${AlreadyReportedError.message}$`)],
});

const withoutQueryString = (breadcrumb) => {
  const url = breadcrumb.metadata && breadcrumb.metadata.url;

  if (!url) {
    return breadcrumb;
  }

  return { ...breadcrumb, metadata: { ...breadcrumb.metadata, url: pathOf(url) } };
};

appsignal.use(windowEventsPlugin());
appsignal.use(networkBreadcrumbsPlugin({ ignoreUrls: [/appsignal-endpoint\.net/] }));

appsignal.addOverride((span) => {
  const { breadcrumbs } = span.serialize();

  if (breadcrumbs) {
    span.setBreadcrumbs(breadcrumbs.map(withoutQueryString));
  }

  return span;
});
